import React from "react";

const Footer = () => {
    return (
      <footer className="my-footer">
        <small>
          &copy; 2022 Todo App by <a href="https://webdevelopermaxi.eu.org" target="_blank" rel="noreferrer">Maxi</a>. All Rights Reserved.</small>
      </footer>
    )
}

export default Footer;
